export enum GroupOptionsEnums {
	INVOICE = 'InvoiceGroupOption',
	INTAKE_MONTH_GROUP_OPTION = 'IntakeMonthGroupOption',
	INTAKE_YEAR_GROUP_OPTION = 'IntakeYearGroupOption',
	REVIEW_DATE_GROUP_OPTION = 'ReviewDateGroupOption'
}
